import { DatePicker } from '@mui/x-date-pickers';
import { useToastContext } from 'components/alert/ToastContext';
import { Label } from 'components/input/Label';
import ReportEdit from 'components/reports/ReportEdit';
import { useFilter } from 'contexts/FilterContext';
import dayjs from 'dayjs';
import saveAs from 'file-saver';
import { BaseModel } from 'model/BaseModel';
import FamiliaProduto from 'model/administracao/cadastro/produto/FamiliaProduto';
import OrigemProduto from 'model/administracao/cadastro/produto/OrigemProduto';
import Produto from 'model/administracao/cadastro/produto/Produto';
import Pageable from 'model/page/Pageable';
import Deposito from 'model/suprimentos/Deposito';
import MovimentoEstoque from 'model/suprimentos/MovimentoEstoque';
import Transacao from 'model/suprimentos/Transacao';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { Column, ColumnFilterElementTemplateOptions } from 'primereact/column';
import { ColumnGroup } from 'primereact/columngroup';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { DataTable, DataTableFilterMeta, DataTableStateEvent } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Row } from 'primereact/row';
import { SplitButton } from 'primereact/splitbutton';
import { useLoadingContext } from 'provider/LoadingProvider';
import { useEffect, useState } from 'react';
import MovimentoEstoqueService from 'service/suprimentos/MovimentoEstoqueService';
import UsuarioLogadoService from 'service/usuario/UsuarioLogadoService';
import { converterDataHora } from 'utils/convert';
import { IdMatchModeOptions, ListMatchModeOptions, ProdutoFilterTemplate, TextMatchModeOptions, dateRangeFilterTemplate, filterApplyTemplate, statusFilterTemplate } from 'utils/filterUtils';
import ObservacaoMovimentoModal from './ObservacaoMovimentoModal';

interface Props {

}

const movimentoEstoqueService = new MovimentoEstoqueService();
const usuarioLogadoService = new UsuarioLogadoService();

function MovimentoEstoqueConsulta(props: Props) {

    const { msgErro } = useToastContext();

    const { startLoading, stopLoading } = useLoadingContext();

    const [editaRelatorio, setEditaRelatorio] = useState<boolean>(false);
    const [visibleEditarRelatorio, setVisibleEditarRelatorio] = useState<boolean>(false);
    const [movimentoSelecionado, setMovimentoSelecionado] = useState<MovimentoEstoque | null>(null);
    const [visibleModalObservacao, setVisibleModalObservacao] = useState(false);
    const [dialogRelatorioPrecoMedio, setDialogRelatorioPrecoMedio] = useState<{ visible: boolean, cdProduto: string, dataInicio: Date | null }>({ visible: false, cdProduto: '', dataInicio: null });

    const [tableLoading, setTableLoading] = useState<boolean>(false);

    const defaultFilters = {
        origemProduto: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        familiaProduto: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        produto: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        deposito: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        transacao: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        dataMovimento: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        lote: {
            constraints: [
                {
                    value: "",
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        tipo: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.IN,
                }
            ],
            operator: FilterOperator.AND
        }
    }

    const filterContext = useFilter();
    const screen = "movimentoEstoqueConsulta";

    const [pageable, setPageable] = useState(new Pageable(0, 10, "dataMovimento,desc", 0));
    const [filtrando, setFiltrando] = useState<boolean>(false);
    const [list, setList] = useState<BaseModel[]>([]);
    const [totalElements, setTotalElements] = useState<number>(0);
    const [podeExcluir, setPodeExcluir] = useState<boolean>(false);

    const [saldoAnterior, setSaldoAnterior] = useState<number>(0);
    const [totalEntrada, setTotalEntrada] = useState<number>(0);
    const [totalSaida, setTotalSaida] = useState<number>(0);
    const [saldo, setSaldo] = useState<number>(0);

    const [confirmDeleteMovimento, setConfirmDeleteMovimento] = useState({ visible: false, movimento: new MovimentoEstoque() });
    const [confirmDeleteTransferencia, setConfirmDeleteTransferencia] = useState({ visible: false, movimento: new MovimentoEstoque() });

    const [visibleConfiguracoes, setVisibleConfiguracoes] = useState<boolean>(false);
    const [esconderCodigos, setEsconderCodigos] = useState<boolean>(false);

    const [familias, setFamilias] = useState<FamiliaProduto[]>([]);
    const [origens, setOrigens] = useState<OrigemProduto[]>([]);
    const [produtos, setProdutos] = useState<Produto[]>([]);
    const [depositos, setDepositos] = useState<Deposito[]>([]);
    const [transacoes, setTransacoes] = useState<Transacao[]>([]);

    const [filters, setFilters] = useState<DataTableFilterMeta>(filterContext.filters[screen] ? filterContext.filters[screen] : defaultFilters);

    const filterField = (options: ColumnFilterElementTemplateOptions, list: any, label?: string) => {
        return <Dropdown value={options.value} options={list}
            onChange={(e) => options.filterCallback(e.value)}
            optionLabel={label || "nome"} optionValue="codigo" placeholder="Qualquer" className="p-column-filter" />
    }

    const numberTemplate = (rowData: any, options: any) => {
        if (rowData[options.field] === null || rowData[options.field] === undefined) {
            return "";
        }
        return new Intl.NumberFormat('pt-BR', { style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 6 }).format(rowData[options.field]);
    };

    const realTemplate = (rowData: any, options: any) => {
        if (rowData[options.field] === null || rowData[options.field] === undefined) {
            return "";
        }

        return new Intl.NumberFormat('pt-BR', { style: 'currency', minimumFractionDigits: 0, maximumFractionDigits: 2, currency: 'BRL' }).format(rowData[options.field]);
    };

    const totalTemplate = (rowData: any) => {
        return new Intl.NumberFormat('pt-BR', { style: 'currency', minimumFractionDigits: 0, maximumFractionDigits: 2, currency: 'BRL' }).format(rowData.valorTotal);
    };

    const { msgAlerta, msgSucesso } = useToastContext();

    useEffect(() => {
        setEsconderCodigos(localStorage.getItem("esconderCodigos") == "true")
        usuarioLogadoService.getAcoesUsuarioLogado().then((resposta) => {
            setEditaRelatorio(usuarioLogadoService.usuarioTemAcao(resposta, "RELATORIO_MOVIMENTO_ESTOQUE"));
            setPodeExcluir(usuarioLogadoService.usuarioTemAcao(resposta, "MOVIMENTO_ESTOQUE_EXCLUIR"));
        }).catch((erro) => {
            console.log(erro);
        });
        movimentoEstoqueService.familias().then(lista => {
            setFamilias(lista);
        }).catch(err => {
            console.log(err);
        });
        movimentoEstoqueService.origens().then(lista => {
            setOrigens(lista);
        }).catch(err => {
            console.log(err);
        });
        movimentoEstoqueService.getProdutos().then(lista => {
            setProdutos(lista);
        }).catch(err => {
            console.log(err);
        });
        movimentoEstoqueService.getDepositos().then(lista => {
            setDepositos(lista);
        }).catch(err => {
            console.log(err);
        });
        movimentoEstoqueService.getTransacoes().then(lista => {
            setTransacoes(lista);
        }).catch(err => {
            console.log(err);
        });
    }, [])

    useEffect(() => {
        buscar();

    }, [pageable, filters]);

    function buscar() {
        filterContext.updateFilters(screen, filters);
        setTableLoading(true);
        movimentoEstoqueService.pesquisar(pageable, filters).then((response) => {
            setList(response.content);
            setTotalElements(response.totalElements);
            setSaldoAnterior(response.totalizadores.saldoAnterior);
            setTotalEntrada(response.totalizadores.totalEntrada);
            setTotalSaida(response.totalizadores.totalSaida);
            setSaldo(response.totalizadores.saldo);
            setTableLoading(false);
        }).catch((error) => {
            console.log(error);
            setTableLoading(false);
        });
    }

    const clearFilter = () => {
        setFilters(defaultFilters || {});
    }

    function excluir(movimento: MovimentoEstoque) {
        movimentoEstoqueService.excluir(movimento).then(() => {
            msgSucesso("Sucesso", 'Movimento excluído com sucesso');
            buscar();
        }).catch((error) => {
            msgAlerta("Alerta", error?.data?.message || "Não foi possível excluir o movimento de estoque");
            console.log(error);
        });
    }

    const botoesExtra = () => {
        const model = [{
            label: "Relatório c/ preço médio",
            icon: "pi pi-pencil",
            command: () => setDialogRelatorioPrecoMedio({ visible: true, cdProduto: '', dataInicio: null })
        }, {
            label: "Editar relatórios",
            icon: "pi pi-pencil",
            command: () => setVisibleEditarRelatorio(true),
            visible: editaRelatorio
        }];
        return <SplitButton
            key="btn2"
            label="Relatório"
            onClick={() => getRelatorio()}
            icon="pi pi-file-pdf"
            model={model}

        />
    }

    const dialogEditarRelatorio = (
        <Dialog header="Editar relatório" visible={visibleEditarRelatorio} onHide={() => setVisibleEditarRelatorio(false)} >
            {editaRelatorio ? <ReportEdit nomeAcao="RELATORIO_MOVIMENTO_ESTOQUE" titulo="Relatório de Movimentações" testarRelatorio={() => { }} style={{ marginBottom: 10 }} /> : null}
            {editaRelatorio ? <ReportEdit nomeAcao="RELATORIO_MOVIMENTO_ESTOQUE" titulo="Relatório de Movimentações com preço médio" testarRelatorio={() => { }} style={{ marginBottom: 10 }} /> : null}

        </Dialog>
    )

    const getRelatorio = () => {
        startLoading();
        movimentoEstoqueService.getRelatorio(filters).then((response) => {
            stopLoading();
            const file = new Blob([response], { type: 'application/pdf' });
            saveAs(file, "RelatorioMovimentoEstoque.pdf");
        }).catch((err) => {
            stopLoading();
            msgErro("Relatório", "Erro ao gerar relatório")
            console.log(err);
        })
    }

    const headerColumnGroup = (
        <ColumnGroup>
            <Row>
                <Column header="Data e Hora" rowSpan={2} sortable sortField='dataMovimento' filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="dataMovimento"
                    filterElement={dateRangeFilterTemplate} showFilterMenuOptions={false} filterApply={filterApplyTemplate} filterMenuStyle={{ zIndex: 50 }} />
                <Column header="Tipo" rowSpan={2} sortable sortField='tipoMovimento' filter showFilterOperator={false} showAddButton={false} filterField="tipo"
                    filterMatchModeOptions={ListMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options) => statusFilterTemplate(options, movimentoEstoqueService.getTipos())} />
                <Column header="Origem" rowSpan={1} colSpan={esconderCodigos ? 1 : 2} filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="origemProduto"
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options) => filterField(options, origens)} />
                <Column header="Familia" rowSpan={1} colSpan={esconderCodigos ? 1 : 2} filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="familiaProduto"
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options) => filterField(options, familias)} />
                <Column header="Produto" rowSpan={1} colSpan={esconderCodigos ? 1 : 2} filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="produto"
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options) => <ProdutoFilterTemplate options={options} opcoes={produtos} />} />
                <Column header="Lote" sortable sortField='id.cdLote' rowSpan={2} filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="lote"
                    filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
                <Column header="Depósito" rowSpan={1} colSpan={esconderCodigos ? 1 : 2} filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="deposito"
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options) => filterField(options, depositos)} />
                <Column header="Transação" rowSpan={1} colSpan={esconderCodigos ? 1 : 2} filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="transacao"
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options) => filterField(options, transacoes, "descricao")} />
                <Column header="Valor" rowSpan={1} colSpan={2} />
                <Column header="Quantidade" rowSpan={2} sortable sortField='quantidade' />
                <Column header="Usuário" rowSpan={2} sortable sortField='usuario.nome' />
                {podeExcluir ? <Column header="" rowSpan={2} /> : null}
            </Row>
            <Row>
                {!esconderCodigos ? <Column header="Código" sortable sortField='produto.familia.cdOrigem' /> : null}
                <Column header="Nome" sortable sortField='produto.familia.origemProduto.nome' />
                {!esconderCodigos ? <Column header="Código" sortable sortField='produto.cdFamilia' /> : null}
                <Column header="Nome" sortable sortField='produto.familia.nome' />
                {!esconderCodigos ? <Column header="Código" sortable sortField='produto.id.codigo' /> : null}
                <Column header="Nome" sortable sortField='produto.nome' />
                {!esconderCodigos ? <Column header="Código" sortable sortField='deposito.id.codigo' /> : null}
                <Column header="Nome" sortable sortField='deposito.nome' />
                {!esconderCodigos ? <Column header="Código" sortable sortField='transacao.id.codigo' /> : null}
                <Column header="Descrição" sortable sortField='transacao.descricao' />
                <Column header="Unitário" sortable sortField='valorUnitario' />
                <Column header="Total" />
            </Row>
        </ColumnGroup>
    );

    return (
        <div>
            {dialogEditarRelatorio}
            <ConfirmDialog header="Confirmação" message="Deseja realmente excluir o movimento de estoque?" visible={confirmDeleteMovimento.visible}
                acceptLabel='Sim' rejectLabel='Não'
                onHide={() => { setConfirmDeleteMovimento({ visible: false, movimento: new MovimentoEstoque() }) }}
                accept={() => {
                    if (confirmDeleteMovimento.movimento.transferencia) {
                        setConfirmDeleteTransferencia({ visible: true, movimento: confirmDeleteMovimento.movimento });
                        setConfirmDeleteMovimento({ visible: false, movimento: new MovimentoEstoque() });
                    } else {
                        excluir(confirmDeleteMovimento.movimento);
                    }

                }}
                reject={() => { setConfirmDeleteMovimento({ visible: false, movimento: new MovimentoEstoque() }) }}
            />
            <ConfirmDialog header="Confirmação" message="Esse é um movimento de transferência, deseja apagar o movimento vinculado?" visible={confirmDeleteTransferencia.visible}
                acceptLabel='Sim' rejectLabel='Não'
                onHide={() => { setConfirmDeleteTransferencia({ visible: false, movimento: new MovimentoEstoque() }) }}
                accept={() => {
                    confirmDeleteTransferencia.movimento.excluirLigacao = true;
                    excluir(confirmDeleteTransferencia.movimento)
                }}
                reject={() => { excluir(confirmDeleteTransferencia.movimento) }}
            />
            <ObservacaoMovimentoModal visible={visibleModalObservacao} setVisible={(e) => setVisibleModalObservacao(e)} movimentoEstoque={movimentoSelecionado} />
            <Dialog header="Configurações" visible={visibleConfiguracoes} onHide={() => setVisibleConfiguracoes(false)}>
                <div style={{ display: "flex", padding: 20 }}>
                    <Checkbox checked={esconderCodigos} onChange={(e) => {
                        localStorage.setItem("esconderCodigos", e.checked as boolean ? "true" : "false");
                        setEsconderCodigos(e.checked as boolean);
                    }} style={{ marginRight: 8 }} />
                    <label>Esconder códigos</label>
                </div>
            </Dialog>

            {dialogRelatorioPrecoMedio.visible ? <Dialog
                header="Relatório Preço Médio"
                visible={dialogRelatorioPrecoMedio.visible}
                onHide={() => setDialogRelatorioPrecoMedio({ visible: false, cdProduto: '', dataInicio: null })}
                footer={<Button type="button" icon="pi pi-check" onClick={() => {
                    if (!dialogRelatorioPrecoMedio.cdProduto) {
                        msgAlerta("Atenção", "Selecione um produto para gerar o relatório");
                        return;
                    }
                    startLoading();
                    movimentoEstoqueService.getRelatorioPrecoMedio(dialogRelatorioPrecoMedio.cdProduto, dialogRelatorioPrecoMedio.dataInicio).then((response) => {
                        stopLoading();
                        const file = new Blob([response], { type: 'application/pdf' });
                        saveAs(file, "RelatorioMovimentoEstoquePrecoMedio.pdf");
                        setDialogRelatorioPrecoMedio({ visible: false, cdProduto: '', dataInicio: null });
                    }).catch((err) => {
                        stopLoading();
                        msgErro("Relatório", "Erro ao gerar relatório")
                        console.log(err);
                    })
                }}>
                    Gerar
                </Button>}
            >
                <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                        <Label obrigatorio>Produto</Label>
                        <Dropdown value={dialogRelatorioPrecoMedio.cdProduto} options={produtos} filter filterBy='codigo'
                            onChange={(e) => setDialogRelatorioPrecoMedio({ ...dialogRelatorioPrecoMedio, cdProduto: e.value })}
                            itemTemplate={(option: Produto) => option.codigo + " - " + option.nome}
                            optionLabel={"nome"} optionValue="codigo" placeholder="Qualquer" className="p-column-filter" />
                    </div>

                    <div style={{ display: "flex", flexDirection: "column" }}>
                        <Label obrigatorio>Data Início</Label>
                        <DatePicker
                            slotProps={{
                                popper: {
                                    disablePortal: true,
                                },
                            }}
                            value={dialogRelatorioPrecoMedio.dataInicio ? dayjs(dialogRelatorioPrecoMedio.dataInicio) : null}
                            onChange={value => {
                                if (value?.toDate())
                                    setDialogRelatorioPrecoMedio({ ...dialogRelatorioPrecoMedio, dataInicio: value?.toDate() })
                            }}
                        />
                    </div>
                </div>


            </Dialog> : null}

            <DataTable
                loading={tableLoading}
                onSort={(e: DataTableStateEvent) => {
                    let sort = e.sortField ? e.sortField : "";
                    sort += e.sortOrder === 1 ? ",asc" : e.sortOrder === -1 ? ",desc" : "";
                    setPageable({ ...pageable, sort: sort });

                }}
                sortField={pageable.sort.split(",")[0]}
                sortOrder={pageable.sort.split(",")[1] === "asc" ? 1 : pageable.sort.split(",")[1] === "desc" ? -1 : 0}
                filters={filters}
                onFilter={(e) => setFilters(e.filters)}
                header={<div style={{ display: "flex", justifyContent: "space-between", textAlign: 'center', alignContent: "center" }}>
                    <span style={{ textAlign: 'center', width: "100%", alignSelf: "center", position: 'relative' }}>Movimentações de estoque</span>
                    <div style={{ display: "flex" }}>
                        <Button type="button" icon="pi pi-cog" onClick={() => setVisibleConfiguracoes(true)} style={{ marginRight: 8 }} />
                        <Button type="button" icon="pi pi-filter-slash" label="Limpar" outlined onClick={clearFilter} style={{ marginRight: 8 }} />
                        {botoesExtra()}
                    </div>
                </div>}
                headerColumnGroup={headerColumnGroup}
                value={list}
                scrollable
                emptyMessage="Nenhum registro encontrado"
                first={pageable.first} rows={10} lazy
                paginator={true} totalRecords={totalElements}
                onPage={(event) => {
                    setPageable({ ...pageable, page: event.page !== undefined ? event.page : 0, first: event.first });
                }}
                selectionMode="single"
                selection={movimentoSelecionado!}
                onSelectionChange={(e) => {
                    setMovimentoSelecionado(e.value as MovimentoEstoque)
                }}
                onRowDoubleClick={(e) => { setVisibleModalObservacao(true) }}
            >
                <Column field="dataMovimento" body={(rowData) => converterDataHora(rowData.dataMovimento)} style={{ minWidth: "160px" }}></Column>
                <Column field="tipoMovimento" body={(rowData) => movimentoEstoqueService.getTipoMovimento(rowData.tipoMovimento)} style={{ minWidth: "100px" }}></Column>
                {!esconderCodigos ? <Column field="produto.familiaProduto.origemProduto.codigo" style={{ minWidth: "75px" }}></Column> : null}
                <Column field="produto.familiaProduto.origemProduto.nome" style={{ minWidth: "200px" }}></Column>
                {!esconderCodigos ? <Column field="produto.familiaProduto.codigo" style={{ minWidth: "75px" }}></Column> : null}
                <Column field="produto.familiaProduto.nome" style={{ minWidth: "200px" }}></Column>
                {!esconderCodigos ? <Column field="produto.codigo" style={{ minWidth: "75px" }}></Column> : null}
                <Column field="produto.nome" style={{ minWidth: "200px" }}></Column>
                <Column field="lote" style={{ minWidth: "100px" }}></Column>
                {!esconderCodigos ? <Column field="deposito.codigo" style={{ minWidth: "75px" }}></Column> : null}
                <Column field="deposito.nome" style={{ minWidth: "200px" }}></Column>
                {!esconderCodigos ? <Column field='transacao.codigo' style={{ minWidth: "75px" }}></Column> : null}
                <Column field='transacao.descricao' style={{ minWidth: "200px" }}></Column>
                <Column field='valorUnitario' body={realTemplate}></Column>
                <Column body={totalTemplate}></Column>
                <Column field="quantidade" style={{ minWidth: "115px" }} body={numberTemplate}></Column>
                <Column field="usuario.nome" style={{ minWidth: "100px" }}></Column>
                {podeExcluir ? <Column body={(rowData) => <Button icon="pi pi-trash" onClick={(e) => {
                    setConfirmDeleteMovimento({ visible: true, movimento: rowData });
                }} />} ></Column> : null}
            </DataTable>

            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 8 }}>
                <div style={{ display: "flex", flexDirection: "column", marginRight: 8 }}>
                    <Label>Saldo anterior:</Label>
                    <InputText id="saldoAnterior" value={new Intl.NumberFormat('pt-BR', { style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 6 }).format(saldoAnterior)} readOnly />
                </div>
                <div style={{ display: "flex", flexDirection: "column", marginRight: 8 }}>
                    <Label>Total entrada:</Label>
                    <InputText id="totalEntrada" value={new Intl.NumberFormat('pt-BR', { style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 6 }).format(totalEntrada)} readOnly />
                </div>
                <div style={{ display: "flex", flexDirection: "column", marginRight: 8 }}>
                    <Label>Total saída:</Label>
                    <InputText id="totalSaida" value={new Intl.NumberFormat('pt-BR', { style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 6 }).format(totalSaida)} readOnly />
                </div>
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <Label>Saldo:</Label>
                    <InputText id="saldo" value={new Intl.NumberFormat('pt-BR', { style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 6 }).format(saldo)} readOnly />
                </div>
            </div>
        </div>
    );
};

export default MovimentoEstoqueConsulta;